// src/utils/errorLogger.js
const ERROR_QUEUE_KEY = 'offline_error_queue'
const ERROR_HISTORY_KEY = 'recent_errors' // สำหรับดักการส่งซ้ำ (ใช้ Session Storage)
const ERROR_SEND_LOG_KEY = 'error_send_log' // เวลาที่ยิงสำเร็จ ใช้คุมเพดานต่อชั่วโมง (ใช้ Session Storage เพื่อให้รอดการกด F5)
const MAX_PAYLOAD_SIZE = 100000 // ลิมิตขนาดข้อมูลที่ประมาณ 100KB
// ปัญหาเดิมที่ซ้ำเรื่อยๆ จะถูกถ่างช่วงเงียบขึ้นทีละขั้น: 5 → 10 → 20 → 60 นาที
// (ยิงครั้งแรกทันที ครั้งที่ 2 ต้องห่าง 5 นาที ครั้งที่ 3 ห่าง 10 นาที ... จากนั้นคงที่ที่ 60 นาที)
const BACKOFF_STEPS_MS = [300000, 600000, 1200000, 3600000]
const SPAM_DELAY_MS = BACKOFF_STEPS_MS[0] // ช่วงเงียบขั้นแรก (ใช้อ้างอิงในข้อความ)
const MAX_BACKOFF_MS = BACKOFF_STEPS_MS[BACKOFF_STEPS_MS.length - 1]
// ปัญหาเดิมถูกรายงานไปแล้ว n ครั้ง → หลังครั้งที่ n ต้องเงียบอีกกี่มิลลิวินาที
// รายงานครั้งที่ 1 → เงียบ 5 นาที, ครั้งที่ 2 → 10 นาที, ครั้งที่ 3 → 20 นาที, ครั้งที่ 4 เป็นต้นไป → 60 นาที
const backoffFor = (n) => BACKOFF_STEPS_MS[Math.min(Math.max((n || 0) - 1, 0), BACKOFF_STEPS_MS.length - 1)]
const BURST_WINDOW_MS = 8000 // รวบ error ที่เกิดรัวๆ ภายใน 8 วิ ให้เป็นข้อความเดียว
const MAX_SENDS_PER_HOUR = 30 // เพดานกันยิงถล่ม Discord (เกินแล้วปิดเสียงชั่วคราว)
const SEND_GAP_MS = 600 // เว้นจังหวะระหว่างยิง กัน Discord ตอบ 429 (rate limit 5 ครั้ง/2 วิ)
const MAX_EMBEDS_PER_MESSAGE = 10 // Discord รับได้ 10 embed ต่อข้อความ — รวบหลายปัญหาไว้ในข้อความเดียว
const MAX_EMBED_CHARS_PER_MESSAGE = 5200 // Discord จำกัดรวมทุก embed ที่ 6000 ตัวอักษร เผื่อไว้หน่อย
const MAX_MESSAGES_PER_FLUSH = 3 // ต่อให้พังยับแค่ไหน หนึ่งรอบ flush ยิงไม่เกิน 3 ข้อความ
const DISCORD_WEBHOOK_URL = 'https://discord.com/api/webhooks/1542203650389049436/l3lDYo_vFxbqprfEaeFk4MxHhk8A0_HLVwNBr6nUl0lb2XIRD2JAtTsRw2MLIXtZSJDh' // 🔹 Webhook ของ betask-linked-app (ฝั่ง Admin)

// 🔇 ประตูหลังไว้ปิดเสียงเฉพาะจุดที่รู้อยู่แล้วว่าพังประจำและไม่ใช่บั๊ก
// ใส่เป็นชิ้นส่วนของ path เช่น '/lineconfig/get' — ปกติควรว่างไว้ ใช้เมื่อจำเป็นจริงๆ
const IGNORE_PATH_KEYWORDS = []

// --- ฟังก์ชันช่วยเหลือ (Helpers) สำหรับความปลอดภัย ---

// ระบบเซนเซอร์ข้อมูลส่วนบุคคลถูกนำออกตามคำขอ (แสดงข้อมูลดิบทั้งหมด)

// 1. ตัวตรวจจับข้อจำกัดขนาดของ Payload (ป้องกัน Localstorage แตกบึ้ม)
const isTooLarge = (payloadStr) => {
  return typeof payloadStr === 'string' && payloadStr.length > MAX_PAYLOAD_SIZE
}

// 2. ตัดส่วนที่ "ไม่ซ้ำกันแต่ไม่มีความหมาย" ออกจาก path (query string / id ที่วิ่งไปเรื่อยๆ)
//    เพื่อให้ /booking/get?date=1 กับ /booking/get?date=2 นับเป็นปัญหาเดียวกัน
const normalizePath = (rawUrl) => {
  let p = String(rawUrl || '')
  try {
    p = new URL(p, window.location.origin).pathname
  } catch (e) {
    p = p.split('?')[0]
  }
  return p
    .replace(/\/(U|SD_)[A-Za-z0-9_-]{6,}/g, '/:shopId') // LINE shop id
    .replace(/\/[0-9a-fA-F]{12,}/g, '/:id') // mongo id / hash
    .replace(/\/\d+/g, '/:id') // running id
    .substring(0, 120)
}

// 3. ตัดตัวเลขที่วิ่งไปเรื่อยๆ ออกจากข้อความ error ฝั่ง JS
const normalizeMessage = (msg) => {
  return String(msg || '')
    .replace(/\d+/g, '#')
    .replace(/\s+/g, ' ')
    .trim()
    .substring(0, 120)
}

// 4. 🔑 "ลายนิ้วมือ" ของ error — ตัวชี้ขาดว่า error สองตัวคือปัญหาเดียวกันหรือไม่
//    ใช้แทนการตัดข้อความ 50 ตัวแรก ซึ่งตัดไม่ถึง path ทำให้ API error ทุกตัวกลายเป็นก้อนเดียวกัน
const API_ERROR_RE = /^API Error \[([^\]]+)\]: (\S+) (\S+)/
const makeFingerprint = (errorMsg, source) => {
  const msg = String(errorMsg || '')
  const matched = msg.match(API_ERROR_RE)
  // API error → แยกตาม method + status + path (คนละ endpoint = คนละปัญหา)
  if (matched) return `api|${matched[2]}|${matched[1]}|${normalizePath(matched[3])}`
  // JS/Vue error → แยกตามจุดเกิด + ข้อความ
  return `js|${normalizeMessage(source)}|${normalizeMessage(msg)}`
}

// 5. เช็คว่า path นี้ถูกสั่งปิดเสียงไว้หรือเปล่า
const isIgnored = (errorMsg) => {
  if (IGNORE_PATH_KEYWORDS.length === 0) return false
  const msg = String(errorMsg || '')
  return IGNORE_PATH_KEYWORDS.some(keyword => msg.includes(keyword))
}

// 6. ดึงข้อมูล session ของแอดมิน (vue-session เก็บไว้ที่ sessionStorage key: vue-session-key)
const getSessionData = () => {
  try {
    const sessionStr = sessionStorage.getItem('vue-session-key')
    if (sessionStr) {
      const parsed = JSON.parse(sessionStr)
      if (parsed && parsed.data) return parsed.data
    }
  } catch (e) {}

  // Fallback: แอปนี้ backup session ไว้ที่ localStorage ชื่อ sessionData ด้วย
  try {
    const backupStr = localStorage.getItem('sessionData')
    if (backupStr) return JSON.parse(backupStr) || {}
  } catch (e) {}

  return {}
}

// 7. แปลข้อความ Error แบบสั้นๆ และบอกหน้าเว็บที่เกิดปัญหา
const translateErrorForNonDev = (errorMsg, source, fullUrl) => {
  const msg = String(errorMsg).toLowerCase()

  // พยายามดึงชื่อหน้า (path) และ query string จาก url
  let pathName = '-'
  try {
    const parsedUrl = new URL(fullUrl)
    pathName = String(parsedUrl.pathname + parsedUrl.search)
      .replace(/`/g, "'") // 🛡️ กัน backtick พังในกล่องโค้ด Discord
      .substring(0, 300) // 🛡️ กัน String ยาวเกินไปจนบอท Error
  } catch (e) {}

  let issueType = 'ไม่ทราบสาเหตุ'

  if (msg.includes('network error') || msg.includes('cors')) {
    issueType = 'ข้อผิดพลาดด้านการเชื่อมต่ออินเทอร์เน็ต (Network)'
  } else if (msg.includes('500') || msg.includes('internal server')) {
    issueType = 'ข้อผิดพลาดที่เซิร์ฟเวอร์ (API Server Down)'
  } else if (msg.includes('400') || msg.includes('401') || msg.includes('403') || msg.includes('404') || msg.includes('422')) {
    issueType = 'ข้อผิดพลาดเกี่ยวกับข้อมูลที่ส่งไป API (API Reject)'
  } else if (String(source).includes('Vue') || String(source).includes('Promise')) {
    issueType = 'ข้อผิดพลาดที่ระบบแสดงผล (Frontend Bug)'
  }

  return `พบปัญหา: ${issueType}\nที่หน้าเว็บ: ${pathName}`
}

// --- ฟังก์ชันหลักในการทำงาน (Core Logger) ---

// สร้างการ์ด (embed) หนึ่งใบต่อหนึ่งปัญหา
// compact = โหมดประหยัดพื้นที่ ใช้ตอนยัดหลายปัญหาไว้ในข้อความเดียว
const buildEmbed = (errorData, compact) => {
  const count = errorData.count || 1
  const suppressed = errorData.suppressed || 0
  const repeatNote = count > 1 ? `\n**🔁 เกิดซ้ำ ${count} ครั้ง ภายใน ${BURST_WINDOW_MS / 1000} วินาที**` : ''
  const mutedWindowMin = errorData.mutedWindowMin || (SPAM_DELAY_MS / 60000)
  const mutedNote = suppressed > 0 ? `\n**🔇 และเคยเกิดอีก ${suppressed} ครั้ง ระหว่างช่วงพักแจ้งเตือน ${mutedWindowMin} นาทีที่ผ่านมา**` : ''
  const devMsgLimit = compact ? 200 : 500

  const embed = {
    title: count > 1 ? `🔥 New System Error (× ${count})` : '🔥 New System Error',
    color: 16711680, // สีแดง (Hex to Decimal)
    description: `**📝 สรุปสาเหตุเบื้องต้น:**\n\`\`\`fix\n${translateErrorForNonDev(errorData.message, errorData.source, errorData.url)}\n\`\`\`${repeatNote}${mutedNote}\n**🤖 ข้อความจากระบบ (Dev):**\n\`\`\`text\n${String(errorData.message).replace(/`/g, "'").substring(0, devMsgLimit)}\n\`\`\``,
    fields: [
      { name: '📍 Source', value: String(errorData.source || '-').substring(0, 100), inline: true },
      { name: '🏪 Shop ID', value: String(errorData.shopId || '-').substring(0, 100), inline: true },
      { name: '🏬 Shop Name', value: String(errorData.shopName || '-').substring(0, 100), inline: true },
      { name: '👤 User', value: String(errorData.userName || '-').substring(0, 100), inline: true },
      { name: '🧬 Fingerprint', value: `\`${String(errorData.fingerprint || '-').substring(0, 200)}\``, inline: false },
      { name: '🔗 URL', value: String(errorData.url).substring(0, 200) }
    ],
    footer: { text: `Time (Client): ${new Date(errorData.timestamp).toLocaleString('th-TH', { timeZone: 'Asia/Bangkok' })}${errorData.nextQuietMin ? ` · ถ้าพังซ้ำ จะเงียบอีก ${errorData.nextQuietMin} นาที` : ''}` }
  }

  // Request/Response body กินที่เยอะ — ใส่เฉพาะตอนที่การ์ดใบนี้ไม่ได้เบียดกับใบอื่น
  if (errorData.requestContext && !compact) {
    embed.fields.push({
      name: '📦 API Request & Response Body',
      value: `\`\`\`json\n${String(errorData.requestContext).replace(/`/g, "'").substring(0, 1000)}\n\`\`\``,
      inline: false
    })
  }

  return embed
}

// ยิงเข้า Discord หนึ่งข้อความ (พ่วงได้สูงสุด 10 การ์ด)
// ใช้ fetch พื้นฐานแทน axios เพื่อไม่ให้วนอ่างกลับเข้า Logger ถ้ายิงพัง
const postToDiscord = async (embeds) => {
  if (!DISCORD_WEBHOOK_URL || !navigator.onLine || embeds.length === 0) return false

  let timerId
  try {
    const payload = { username: '🚨 Betask Admin Error', embeds: embeds }

    // สร้างตัวจับเวลา ป้องกันกรณีจำลอง Offline ขัดข้องแล้ว Discord ค้างรอไม่ยอมตอบ
    const timeoutPromise = new Promise((resolve, reject) => {
      timerId = setTimeout(() => reject(new Error('Discord Timeout (5s)')), 5000)
    })
    // 🛡️ ถ้า fetch เสร็จก่อน จะไม่มีใครรอ timeoutPromise — ต้องแปะ catch เปล่าไว้
    // ไม่งั้นตัวจับเวลาจะเด้ง reject ลอยๆ กลายเป็น unhandled rejection ของแอป
    timeoutPromise.catch(() => {})

    // 🛡️ ห่อ fetch ไว้ เผื่อบาง WebView/ส่วนขยายทำให้ fetch throw ออกมาแบบ sync
    const reqPromise = Promise.resolve().then(() => fetch(DISCORD_WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }))

    const res = await Promise.race([reqPromise, timeoutPromise])

    if (!res.ok) {
      console.error('Discord Webhook ตอบกลับมาว่าพัง (Status):', res.status, await res.text())
      return false
    }
    return true
  } catch (e) {
    console.warn('ไม่สามารถยิง Discord ได้ ลัดคิวเข้า Local Storage ก่อน:', e.message || e)
    return false
  } finally {
    // เคลียร์ตัวจับเวลาทุกเส้นทาง ไม่ว่าจะสำเร็จ ล้มเหลว หรือ throw
    clearTimeout(timerId)
  }
}

// จัดการ์ดลงกล่อง: ไม่เกิน 10 ใบ และไม่เกินโควตาตัวอักษรของ Discord
const packIntoMessages = (items) => {
  const messages = []
  let current = []
  let currentChars = 0

  for (const item of items) {
    const embed = buildEmbed(item.sample, items.length > 1)
    const size = JSON.stringify(embed).length

    if (current.length > 0 && (current.length >= MAX_EMBEDS_PER_MESSAGE || currentChars + size > MAX_EMBED_CHARS_PER_MESSAGE)) {
      messages.push(current)
      current = []
      currentChars = 0
    }

    current.push({ embed: embed, item: item })
    currentChars += size
  }

  if (current.length > 0) messages.push(current)
  return messages
}

// บันทึกใส่ระบบเมื่อไม่มีอินเทอร์เน็ต (Offline Queue)
const saveToOfflineQueue = (errorData) => {
  try {
    const queue = JSON.parse(localStorage.getItem(ERROR_QUEUE_KEY) || '[]')
    // เก็บสูงสุด 50 error ล่าสุดเท่านั้น พอเกินให้เด้งทิ้ง
    if (queue.length < 50) {
      queue.push(errorData)
      localStorage.setItem(ERROR_QUEUE_KEY, JSON.stringify(queue))
    }
  } catch (e) {
    console.error('ไม่สามารถบันทึก error ลงแบบออฟไลน์ได้', e)
  }
}

// --- ระบบพักแจ้งเตือนต่อ "ลายนิ้วมือ" (เก็บใน Session Storage) ---

const readHistory = () => {
  try { return JSON.parse(sessionStorage.getItem(ERROR_HISTORY_KEY) || '{}') } catch (e) { return {} }
}
const writeHistory = (history) => {
  try { sessionStorage.setItem(ERROR_HISTORY_KEY, JSON.stringify(history)) } catch (e) {}
}

// --- ระบบรวบ error ที่เกิดรัวๆ ให้เป็นข้อความเดียว (Burst Buffer) ---

const burstBuffer = new Map() // fingerprint -> { sample, count }
let burstTimer = null
let mutedNotified = false

// ⚠️ ต้องเก็บนอกหน่วยความจำ ไม่งั้นผู้ใช้กด F5 ทีเดียวเพดานต่อชั่วโมงก็รีเซ็ตเป็นศูนย์
// ใช้ sessionStorage เพราะ Login.vue เรียก localStorage.clear() ตอนล็อกอิน (จะโดนล้างทิ้ง)
const readSendLog = () => {
  try {
    const raw = JSON.parse(sessionStorage.getItem(ERROR_SEND_LOG_KEY) || '[]')
    const now = Date.now()
    return Array.isArray(raw) ? raw.filter(t => now - t < 3600000) : []
  } catch (e) { return [] }
}
const writeSendLog = (timestamps) => {
  try { sessionStorage.setItem(ERROR_SEND_LOG_KEY, JSON.stringify(timestamps)) } catch (e) {}
}

let isFlushing = false

const flushBurst = async () => {
  burstTimer = null
  // กันรอบ flush ซ้อนกัน (รอบก่อนอาจยังยิงไม่เสร็จ) — ไม่งั้นเพดานกับประวัติจะนับเพี้ยน
  if (isFlushing) {
    burstTimer = setTimeout(flushBurst, BURST_WINDOW_MS)
    return
  }
  if (burstBuffer.size === 0) return
  isFlushing = true

  try {
    const entries = Array.from(burstBuffer.entries())
    burstBuffer.clear()

    const history = readHistory()
    const now = Date.now()

    // ล้างประวัติเก่าทิ้ง กัน Session Storage บวม
    for (let key in history) {
      // ต้องยาวกว่าขั้นสูงสุด ไม่งั้นจะเผลอลบประวัติทิ้งแล้ว backoff เด้งกลับไปเริ่มใหม่
      if (now - (history[key].t || 0) > MAX_BACKOFF_MS * 2) delete history[key]
    }

    // 1) คัดตัวที่ยังอยู่ในช่วงพักแจ้งเตือนออกไปก่อน — แค่นับสะสมไว้ ไม่ต้องยิง
    const dueItems = []
    for (const [fingerprint, entry] of entries) {
      const record = history[fingerprint]
      const strikes = record ? (record.n || 0) : 0
      if (record && now - record.t < backoffFor(strikes)) {
        record.s = (record.s || 0) + entry.count
        continue
      }
      dueItems.push({
        fingerprint: fingerprint,
        sample: Object.assign({}, entry.sample, {
          count: entry.count,
          suppressed: record ? (record.s || 0) : 0,
          mutedWindowMin: Math.round(backoffFor(strikes) / 60000),
          nextQuietMin: Math.round(backoffFor(strikes + 1) / 60000)
        })
      })
    }

    if (dueItems.length === 0) {
      writeHistory(history)
      return
    }

    // 2) ยัดหลายปัญหาไว้ในข้อความเดียว (การ์ดละปัญหา สูงสุด 10 ใบ/ข้อความ)
    let messages = packIntoMessages(dueItems)

    // 3) เกินโควตาต่อรอบ → ไม่ทิ้ง แต่ดันไปคิวออฟไลน์ไว้ส่งรอบหน้า
    if (messages.length > MAX_MESSAGES_PER_FLUSH) {
      const overflow = messages.slice(MAX_MESSAGES_PER_FLUSH)
      messages = messages.slice(0, MAX_MESSAGES_PER_FLUSH)
      for (const msg of overflow) {
        for (const slot of msg) saveToOfflineQueue(slot.item.sample)
      }
    }

    let isFirstSend = true

    for (const msg of messages) {
      // เพดานต่อชั่วโมง — กัน error loop ยิงถล่มห้องแชท
      const sendLog = readSendLog()
      if (sendLog.length >= MAX_SENDS_PER_HOUR) {
        if (!mutedNotified) {
          mutedNotified = true
          console.warn(`[errorLogger] แตะเพดาน ${MAX_SENDS_PER_HOUR} ข้อความ/ชั่วโมง — ปิดเสียงชั่วคราว`)
        }
        // ยังเก็บลง offline queue ไว้ ไม่ให้ข้อมูลหาย
        for (const slot of msg) saveToOfflineQueue(slot.item.sample)
        continue
      }

      // เว้นจังหวะระหว่างยิง กัน Discord ตอบ 429
      if (!isFirstSend) await new Promise(resolve => setTimeout(resolve, SEND_GAP_MS))
      isFirstSend = false

      const success = await postToDiscord(msg.map(slot => slot.embed))
      if (success) {
        sendLog.push(Date.now())
        writeSendLog(sendLog)
        mutedNotified = false
        const stamp = Date.now()
        for (const slot of msg) {
          const prev = history[slot.item.fingerprint]
          // n = จำนวนครั้งที่รายงานไปแล้ว ใช้เลือกขั้นความเงียบของรอบถัดไป
          history[slot.item.fingerprint] = { t: stamp, s: 0, n: (prev ? (prev.n || 0) : 0) + 1 }
        }
      } else {
        // ยิงไม่ผ่าน (Discord ล่ม/โดนบล็อค) เก็บไว้ก๊อกสอง — ไม่บันทึกเวลาพัก จะได้ลองใหม่ได้
        for (const slot of msg) saveToOfflineQueue(slot.item.sample)
      }
    }

    writeHistory(history)
  } catch (loggerError) {
    // 🛡️ flushBurst ถูกเรียกจาก setTimeout — ถ้า throw จะกลายเป็น unhandled rejection แล้ววนกลับเข้า logger
    try { console.warn('[errorLogger] flush มีปัญหา (ไม่กระทบการทำงานของแอป):', loggerError && loggerError.message) } catch (ignore) {}
  } finally {
    isFlushing = false
  }
}

const enqueueBurst = (fingerprint, errorData) => {
  const existing = burstBuffer.get(fingerprint)
  if (existing) {
    existing.count += 1
  } else {
    burstBuffer.set(fingerprint, { sample: errorData, count: 1 })
  }
  if (!burstTimer) burstTimer = setTimeout(flushBurst, BURST_WINDOW_MS)
}

export const logError = async (errorMsg, source, line, col, errorObj, requestContext = null) => {
  try {
    // จุดที่สั่งปิดเสียงไว้เอง
    if (isIgnored(errorMsg)) return

    // แปลงข้อมูล payload ก่อนส่ง (แสดงข้อมูลดิบทั้งหมด ไม่เซนเซอร์)
    let safeRequestContext = null
    if (requestContext) {
      try {
        const rawStr = typeof requestContext === 'string' ? requestContext : JSON.stringify(requestContext)
        if (isTooLarge(rawStr)) {
          safeRequestContext = `ข้อมูลเยอะเกินขนาด ขอลดทอนเหลือ:\n${String(rawStr).substring(0, 1000)}...`
        } else {
          safeRequestContext = rawStr
        }
      } catch (e) {
        safeRequestContext = `[ข้อมูลซับซ้อนเกินไป แปลงเป็นข้อความไม่ได้: ${e.message}]`
      }
    }

    // พยายามดึง shopId / ชื่อร้าน / ผู้ใช้ จาก session ของแอดมิน
    const sessionData = getSessionData()
    let shopId = sessionData.shopId || null
    const shopName = sessionData.shopName || sessionData.storeName || null
    const userName = sessionData.userName || sessionData.username || null

    // Fallback: ดึง shopId จาก URL Query String
    if (!shopId) {
      try {
        const urlParams = new URLSearchParams(window.location.search)
        shopId = urlParams.get('shopId') || null
      } catch (e) {}
    }

    // แปลงเวลาให้เป็นโซนเมืองไทยโดยเฉพาะ (Asia/Bangkok) แบบ YYYY-MM-DDTHH:mm:ss
    let thaiTimeStr = new Date().toISOString() // fallback
    try {
      thaiTimeStr = new Date().toLocaleString('sv-SE', { timeZone: 'Asia/Bangkok' }).replace(' ', 'T')
    } catch (e) {}

    const fingerprint = makeFingerprint(errorMsg, source)

    // จัดเตรียมข้อมูลที่จะส่ง
    const errorData = {
      message: String(errorMsg || 'Unknown Error').substring(0, 1000),
      source: String(source || 'Unknown Source').substring(0, 200),
      path: window.location.pathname,
      url: window.location.href,
      userAgent: String((navigator && navigator.userAgent) || '-').substring(0, 300),
      timestamp: thaiTimeStr,
      stack: (errorObj && errorObj.stack) ? String(errorObj.stack).substring(0, 2000) : null,
      shopId: shopId,
      shopName: shopName,
      userName: userName,
      fingerprint: fingerprint,
      requestContext: safeRequestContext
    }

    // ตรวจสอบเช็คอินเทอร์เน็ตและสั่งบันทึกข้อมูล
    const msgLower = String(errorMsg || '').toLowerCase()
    const isNetworkError = msgLower.includes('network error') || msgLower.includes('cors')

    // หากเป็น Network Error ให้ข้ามไปเลย ไม่ต้องส่ง Discord และไม่ต้องเก็บลง Local Storage ตามคำขอ
    if (isNetworkError) return

    if (navigator.onLine) {
      // 📢 เข้าคิวรวบ 8 วิ แล้วค่อยยิงเข้า Discord ทีเดียว
      enqueueBurst(fingerprint, errorData)
    } else {
      // ถ้าไม่มีเน็ต ให้เก็บไว้ก่อน
      saveToOfflineQueue(errorData)
    }
  } catch (loggerError) {
    // 🛡️ กฎเหล็ก: ตัว logger ต้องไม่ทำให้แอปพังเด็ดขาด
    // ถ้าปล่อยให้ throw ออกไป มันจะกลายเป็น unhandled rejection → วิ่งกลับเข้า logger → วนไม่จบ
    try { console.warn('[errorLogger] ตัว logger เองมีปัญหา (ไม่กระทบการทำงานของแอป):', loggerError && loggerError.message) } catch (ignore) {}
  }
}

// ตรวจสอบและส่งข้อมูลเมื่อเน็ตกลับมาทำงาน
export const syncOfflineErrors = async () => {
  try {
    if (!navigator.onLine) return

    let queue = []
    try { queue = JSON.parse(localStorage.getItem(ERROR_QUEUE_KEY) || '[]') } catch (e) {}

    if (queue.length === 0) return

    // เคลียร์คิวออกก่อน กันการยิงซ้ำถ้ามีการเรียกซ้อน
    try { localStorage.setItem(ERROR_QUEUE_KEY, '[]') } catch (e) {}

    // ตัด Network Error ทิ้ง (ถือว่าจัดการแล้ว) แล้วจัดที่เหลือลงข้อความแบบรวบการ์ด
    const dueItems = queue
      .filter(errorData => {
        const msgLower = String(errorData.message || '').toLowerCase()
        return !(msgLower.includes('network error') || msgLower.includes('cors'))
      })
      .map(errorData => ({ fingerprint: errorData.fingerprint || '-', sample: errorData }))

    const remainingQueue = []
    let messages = packIntoMessages(dueItems)

    // เคารพเพดานต่อรอบเหมือนกัน ที่เหลือค้างคิวไว้ก่อน
    if (messages.length > MAX_MESSAGES_PER_FLUSH) {
      const overflow = messages.slice(MAX_MESSAGES_PER_FLUSH)
      messages = messages.slice(0, MAX_MESSAGES_PER_FLUSH)
      for (const msg of overflow) {
        for (const slot of msg) remainingQueue.push(slot.item.sample)
      }
    }

    let isFirstSend = true

    for (const msg of messages) {
      const sendLog = readSendLog()
      if (sendLog.length >= MAX_SENDS_PER_HOUR) {
        for (const slot of msg) remainingQueue.push(slot.item.sample)
        continue
      }

      if (!isFirstSend) await new Promise(resolve => setTimeout(resolve, SEND_GAP_MS))
      isFirstSend = false

      const success = await postToDiscord(msg.map(slot => slot.embed))
      if (success) {
        sendLog.push(Date.now())
        writeSendLog(sendLog)
      } else {
        for (const slot of msg) remainingQueue.push(slot.item.sample) // ถ้าส่งไม่ผ่านเก็บไว้ก่อน
      }
    }

    try {
      const current = JSON.parse(localStorage.getItem(ERROR_QUEUE_KEY) || '[]')
      localStorage.setItem(ERROR_QUEUE_KEY, JSON.stringify(remainingQueue.concat(current).slice(0, 50)))
    } catch (e) {}
  } catch (loggerError) {
    // 🛡️ กฎเหล็ก: ตัว logger ต้องไม่ทำให้แอปพังเด็ดขาด
    // ถ้าปล่อยให้ throw ออกไป มันจะกลายเป็น unhandled rejection → วิ่งกลับเข้า logger → วนไม่จบ
    try { console.warn('[errorLogger] ตัว logger เองมีปัญหา (ไม่กระทบการทำงานของแอป):', loggerError && loggerError.message) } catch (ignore) {}
  }
}

window.addEventListener('online', syncOfflineErrors)

// ถ้าผู้ใช้เปลี่ยนแท็บ/ปิดหน้า ให้รีบส่งของที่ค้างในคิวรวบทันที จะได้ไม่หาย
document.addEventListener('visibilitychange', function () {
  if (document.visibilityState === 'hidden' && burstBuffer.size > 0) {
    if (burstTimer) clearTimeout(burstTimer)
    flushBurst()
  }
})



// WEBPACK FOOTER //
// ./src/utils/errorLogger.js